import { useCoursesStore } from '../../../stores/courseStore';
import { CourseContentCard } from '../CourseContentCard';

interface CourseContentListProps {
  contentList: any[];
  className?: string;
  handleOpenContent: (content: any) => void;
  onClickDone?: (content: any) => void;
}

function CourseContentList({
  contentList,
  className,
  onClickDone,
  handleOpenContent,
}: CourseContentListProps) {
  const { loadedCourse } = useCoursesStore();

  return (
    <div className={`flex flex-col gap-lg ${className}`}>
      {contentList
        .sort((a: any, b: any) => {
          if (a.order > b.order) {
            return 1;
          }
          if (a.order < b.order) {
            return -1;
          }
          return 0;
        })
        .map((content: any) => {
          const isSelected = loadedCourse
            ? loadedCourse.selectedContent === content._contentId
            : false;

          return (
            <CourseContentCard
              content={content}
              key={content.contentId}
              selected={isSelected}
              onClick={() => handleOpenContent(content)}
              onClickDone={() => {
                onClickDone && onClickDone(content);
              }}
            />
          );
        })}
    </div>
  );
}

export { CourseContentList };
